module.exports = __webpack_public_path__ + "img/f8a46db749c8f6cdbd2e580240d7e138.png";